<template>
  <div class="new">
    <div class="new-top" v-show="progressActiveIndex == 0">
      备注：如果以下没有发现对应的产品信息，请
      <span class="new-top__fun" @click="goProductInfo()">点击此处</span>
      ,先新建产品信息!</div>
    <progressBar
      class="new-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <div class="new-table" v-show="progressActiveIndex == 0">
      <Table
        :head="productTableHead"
        :body="productList"
        :radioIndex="productTableRadioIndex"
        @changeRadioIndex="changeProductRadioIndex"
        width="1280"
        height="550"></Table>
      <div class="new-fun">
        <div class="new-fun__btn" @click="nextStep()">下一步</div>
      </div>
    </div>
    <div class="new-module" v-show="progressActiveIndex == 1">
      <div class="new-module__title">Listing管理</div>
      <div class="new-module__top">
        <div class="new-module__top__name">Listing信息</div>
      </div>
      <div class="new-module-item">
        <div class="new-module-block">
          <div class="new-module-list__name" style="text-align: start;">
            <span class="new-module-list__star">*</span>
            商品图片
          </div>
          <div class="new-module-img">
            <template v-if="!listing.img">
              <div class="new-module-img__add"></div>
              <input type="file" id="image" class="new-module-img__input" @change="uploadImg()">
              <div class="new-module-img__text">（图片大小不超过1024KB，仅限JPG、JEPG和PNG格式）</div>
            </template>
            <template v-else>
              <!-- <div class="new-module-img__close" @click="removeImg()"></div> -->
              <img :src="'/api/support-server/v1/fileInfo/downloadFile/' + listing.img" alt="" class="new-module-img__image">
            </template>
          </div>
        </div>
        <div class="new-module-block" v-for="(item, index) in basicInfoInputModule" :key="index">
          <div class="new-module-list" v-for="itemIndex in item" :key="itemIndex.data">
            <div class="new-module-list__name">
              <span class="new-module-list__star" v-if="itemIndex.isRequired">*</span>
              {{ itemIndex.name }}：
            </div>
            <div class="new-module-list__input"
              :class="{'new-module-list__input--size' : itemIndex.data === 'size' || itemIndex.data === 'boxSize'}">
              <template v-if="itemIndex.data === 'productStatus'">
                <el-select
                  size="mini"
                  popper-class="productStatusSelect"
                  ref="productStatusSelect"
                  :placeholder="itemIndex.pla"
                  :disabled="itemIndex.isDisable ||isDisable"
                  v-model="listing[itemIndex.data]"
                  collapse-tags
                  multiple>
                  <div class="new-module-list__input-status">
                    <div class="new-module-list__input-module">
                      <div class="new-module-list__input-module__title">
                        必选项1
                        <span class="new-module-list__input-module__tip">(单选)</span>
                      </div>
                      <el-option
                        v-for="option in itemIndex.array.slice(0, 3)"
                        :key="option"
                        :label="option"
                        :value="option">
                        <el-checkbox
                          :label="option"
                          :value="judgeStatusCheckBox(option)"
                          @change="statusCheckChange($event, option)"></el-checkbox>
                      </el-option>
                    </div>
                    <div class="new-module-list__input-module">
                      <div class="new-module-list__input-module__title">
                        必选项2
                        <span class="new-module-list__input-module__tip">(单选)</span>
                      </div>
                      <el-option
                        v-for="option in itemIndex.array.slice(3, 6)"
                        :key="option"
                        :label="option"
                        :value="option">
                        <el-checkbox
                          :label="option"
                          :value="judgeStatusCheckBox(option)"
                          @change="statusCheckChange($event, option)"></el-checkbox>
                        </el-option>
                    </div>
                    <div class="new-module-list__input-module">
                      <div class="new-module-list__input-module__title">
                        非必选项
                        <span class="new-module-list__input-module__tip">(可多选,请如实勾选)</span>
                        <el-option
                          v-for="option in itemIndex.array.slice(6, 9)"
                          :key="option"
                          :label="option"
                          :value="option">
                          <el-checkbox
                            :label="option"
                            :value="judgeStatusCheckBox(option)"
                            @change="statusCheckChange($event, option)"></el-checkbox>
                        </el-option>
                      </div>
                    </div>
                  </div>
                </el-select>
              </template>
              <template v-else-if="itemIndex.data === 'size'">
                <el-input
                  size="mini"
                  type="number"
                  v-for="input in listingSizeInputData"
                  :key="input.data"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="input.pla"
                  v-model="listing[input.data]"></el-input>
              </template>
              <template v-else-if="itemIndex.data === 'boxSize'">
                <el-input
                  size="mini"
                  type="number"
                  v-for="input in boxSizeInputData"
                  :key="input.data"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="input.pla"
                  v-model="listing[input.data]"></el-input>
              </template>
              <template v-else-if="itemIndex.type == 'select'">
                <el-select
                  v-model="listing[itemIndex.data]"
                  size="mini"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="itemIndex.pla">
                  <el-option
                    v-for="(option, index) in itemIndex.array"
                    :key="index"
                    :value="index"
                    :label="option"></el-option>
                </el-select>
              </template>
              <template v-else>
                <el-input
                  size="mini"
                  :type="itemIndex.type"
                  v-model="listing[itemIndex.data]"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="itemIndex.pla"></el-input>
              </template>
            </div>
            <div class="new-module-list__unit">{{ itemIndex.unit }}</div>
          </div>
        </div>
      </div>
      <div class="new-module-item">
        <div class="new-module-block" v-for="(item, index) in listingInputData" :key="index">
          <div class="new-module-list new-module-list--bottom" v-for="itemIndex in item" :key="itemIndex.data">
            <div class="new-module-list__name">
              <span class="new-module-list__star" v-if="itemIndex.isRequired">*</span>
              {{ itemIndex.name }}：
            </div>
            <div class="new-module-list__input"
              :class="{
                'new-module-list__input--prompt': !listing[itemIndex.data] && listing[itemIndex.data] !== 0 && itemIndex.isPrompt,
              }">
              <template v-if="itemIndex.type === 'select'">
                <el-select
                  v-model="listing[itemIndex.data]"
                  size="mini"
                  :disabled="itemIndex.isDisable ||isDisable"
                  :placeholder="itemIndex.pla">
                  <el-option
                    v-for="(option, index) in itemIndex.array"
                    :key="index"
                    :value="index"
                    :label="option"></el-option>
                </el-select>
              </template>
              <template v-else>
                <el-input
                  size="mini"
                  :type="itemIndex.type"
                  :suffix-icon="itemIndex.sufIcon"
                  :prefix-icon="itemIndex.preIcon"
                  v-model="listing[itemIndex.data]"
                  :disabled="itemIndex.isDisable || isDisable"
                  :placeholder="itemIndex.pla"></el-input>
                <div class="new-module-list__function">
                  <template v-if="itemIndex.data === 'barCodeByListing'">
                    <div class="new-module-list__btn">
                      <input id="PDFFileInput" type="file" accept=".pdf" class="new-module-list__function-input" @change="uploadBtnClick">
                      上传
                    </div>
                    <div class="new-module-list__btn" v-if="listing.barCodeByListing">查看</div>
                  </template>
                  <div class="new-module-list__btn" v-if="itemIndex.data === 'sqrkgsl'" @click="searchBtnClick">查询</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="new-module-item">
        <div class="new-module-list new-module-list1">
          <div class="new-module-list__name">
            <span class="new-module-list__star">*</span>
            商品标题：
          </div>
          <div class="new-module-list__input new-module-list__input--title"  :class="{'new-module-list__input--prompt': !listing.title && isPrompt}">
            <el-input size="mini" :disabled="isDisable" v-model="listing.title"></el-input>
          </div>
        </div>
      </div>
      <div class="new-module-bottom">
        <div class="new-module-bottom__btn" @click="newListingBtnClick" v-if="type === 'new'">新建Listing信息</div>
        <div class="new-module-bottom__btn" @click="changeListingBtnClick" v-if="type === 'change'">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ListingNewModule, Listing } from './class'
import { ProductList } from 'views/summary/component/productInfo/class'
import { ShopSetting } from 'views/summary/component/shopExpenseSettings/class';
import { SummaryNewModule, summaryTab } from "common/dataClass/Summary";
import globalData from 'common/globalData'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import ProductAxios from 'service/product'
import DefaultAxios from 'service/default'
import StoreAxios from 'service/store'
export default {
  name: 'newListing',
  components: {
    progressBar, Table
  },
  data(){
    return {
      isDisable: false,
      isPrompt: false,
      /**进度条数据 */
      progressData: ListingNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 0,
      /**产品表头 */
      productTableHead: ListingNewModule.NEWPRRODUCTTABLEHEAD(),
      productList: [],
      /**表格选择索引 */
      productTableRadioIndex: null,
      listing: new Listing(),
      listingBasicInfoInputData: ListingNewModule.NEWBASICINFO(),
      /**产品基本信息 */
      basicInfoInputModule: ListingNewModule.NEWBASICINFO(),
      /**lisitng信息 */
      listingInputData: ListingNewModule.LISTINGINFOINPUTMODULE(),
      /**产品状态 */
      listingStatusInputOptions: globalData.logisticsStatusInputOptions,
      /**包装尺寸 */
      listingSizeInputData: ListingNewModule.NEWSIZE(),
      boxSizeInputData: ListingNewModule.NEWBOXSIZE(),
      /**店铺数据 */
      storeList: [],
    }
  },
  methods:{
    /**切换产品页面 */
    goProductInfo(){
      this.$emit('go', {
        id: 'newProductInfo',
        name: '新建产品信息',
      })
    },
    /**表格选择索引改变事件 */
    changeProductRadioIndex(index){
      this.productTableRadioIndex = index
    },
    /**获取产品列表 */
    async getProductList(bool = false){
      let res = await ProductAxios.productList({})
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      if(bool) this.$message.success('查询成功')
      let list = res.data.info
      this.productList.splice(0, this.productList.length)
      list.map(l => {
        let productData = new ProductList()
        productData.backendListDataParsing(l)
        this.productList.push(productData)
      })
    },
    /**下一步 */
    nextStep(){
      if(this.productTableRadioIndex == null){
        this.$message.error('请先选择产品信息')
        return;
      }
      let obj = this.productList[this.productTableRadioIndex]
      let keys = Object.keys(obj)
      keys.map(key => {
        this.listing[key] = this.productList[this.productTableRadioIndex][key]
        if(key == 'productStatus'){
          this.listing[key] = this.productList[this.productTableRadioIndex][key].map(index => globalData.productStatusInputOptions[index])
        }
      })
      this.progressActiveIndex ++
    },
    /**上传图片 */
    async uploadImg(){
      /**图片最大限制 */
      let imgMaxSize = 1 * 1024 * 1024;
      let file = document.getElementById('image').files[0]
      if(file.size > imgMaxSize){
        this.$message.error('文件不能大于1M！')
        return
      }
      if(!/image\/\w+/.test(file.type)){
        this.$message.error('文件必须为图片！')
        return
      }
      if(!file) return;
      let res = await DefaultAxios.uploadImg(file)
      if(res.data.code === 1){
        this.$message.success('上传成功')
        this.listing.img = res.data.info.fileId
      }
    },
    /**删除图片 */
    removeImg(){
      this.listing.img = ''
    },
    /**产品状态select checkBox点击事件 */
    statusCheckChange(bool, label){
      let resultIndexArr = []
      let arr = this.listing.productStatus
      if(!bool){
        arr.push(label)
      }else{
        arr = arr.filter(s => s != label)
      }
      arr = arr.map(v => this.listingStatusInputOptions.indexOf(v))
      let battery = arr.filter(i => i >=0 && i <= 2).pop()
      let magnetic = arr.filter(i => i >=3 && i <= 5).pop()
      let otherArr = arr.filter(i => i >= 6)
      if(battery !== undefined) resultIndexArr.push(battery)
      if(magnetic !== undefined) resultIndexArr.push(magnetic)
      resultIndexArr = resultIndexArr.concat(otherArr)
      this.listing.productStatus = resultIndexArr.map(i => this.listingStatusInputOptions[i])
    },
    /**判断当前checkBox是否被选择 */
    judgeStatusCheckBox(label){
      return this.listing.productStatus.includes(label)
    },
    /**搜索按钮点击事件 */
    searchBtnClick(){
      window.open('https://www.hs-bianma.com/index.php')
    },
    /**返回Listing列表页面 */
    returnListPage(){
      let functionMenu = SummaryNewModule.NEWFUNCTIONMENU()
      let tab = new summaryTab(
        functionMenu.sale.list.salesInformation.list.listing.name,
        functionMenu.sale.list.salesInformation.list.listing.id
      )
      this.$emit('delete', {id : 'newListing', tab: tab})
    },
    /**判断数据是否全部输入 */
    judgeSendAxios(){
      let bool = true
      for(let i = 0; i < this.listingInputData.length; i ++){
        let keys = Object.keys(this.listingInputData[i])
        for(let j = 0; j < keys.length; j ++){
          let obj = this.listingInputData[i][keys[j]]
          if(this.listing[obj.data] == undefined || this.listing[obj.data] == ''){
            obj.isPrompt = true
            bool = false
          }
        }
      }
      if(this.listing.title == ''){
        this.isPrompt = true
        bool = false
      }
      return bool
    },
    /**新建Lisitng信息 */
    async newListingBtnClick(){
      let bool = this.judgeSendAxios()
      if(!bool) {
        this.$message.error('请将信息补充完整')
        return;
      }
      let res = await ProductAxios.newListing(this.listing.getNewListingBody)
      if(res.data.code != 1){
        this.$message.error(res.data.info)
        return;
      }
      this.$message.success('新建成功')
      this.returnListPage()
    },
    /**修改listing信息 */
    async changeListingBtnClick(){
      let bool = this.judgeSendAxios()
      if(!bool) {
        this.$message.error('请将信息补充完整')
        return;
      }
      let res = await ProductAxios.changeListing(this.listing.getNewListingBody)
      if(res.data.code != 1){
        this.$message.error(res.data.info)
        return;
      }
      this.$message.success('修改成功')
      this.returnListPage()
    },
    /**获取店铺信息 */
    async getStoreList(){
      let res = await StoreAxios.getAll()
      if(res.data.code != 1){
        this.$message.error(res.data.info)
        return;
      }
      let arr = res.data.info
      this.storeList = arr.map(object => {
        let obj = new ShopSetting()
        obj.backendDetailDataParsing(object)
        return obj
      })
      this.listingInputData[0].store.array = this.storeList.map(object => object.name)
    },
    /**上传按钮点击事件 */
    async uploadBtnClick(){
      let imgMaxSize = 500 * 1024 ;
      let files
      files = document.getElementById('PDFFileInput').files[0]
      if(files.size > imgMaxSize){
        this.$message.error('文件不能大于500k！')
        return
      }
      let res = await DefaultAxios.uploadFile(files)
      if(res.data.code != 1){
        this.$message.error(res.data.info)
        return;
      }
      this.$message.success('上传成功')
      this.listing.barCodeByListing = res.data.info.fileId
    },
    /**查看文件 */
    async watchBtnClick(){
      let res = await DefaultAxios.watchFile(this.listing.barCodeByListing)
      let blob = new Blob([res.data], { type: 'application/pdf;chartset=UTF-8' }) // 缓存的下载数据
      let href = URL.createObjectURL(blob)
      window.open(href)
    }
  },
  computed:{
    type(){
      return this.$store.state.newListing.type
    },
    id(){
      return this.$store.state.newListing.id
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal){
        let obj = {
          new: () => {
            this.progressActiveIndex = 0
          },
          change: async () => {
            this.progressActiveIndex = 1
            let value = JSON.parse(this.$store.state.newListing.value)
            let listingKeys = Object.keys(this.listing)
            listingKeys.map(key => this.listing[key] = value[key])
            let res = await ProductAxios.getProductDetail(value.id)
            if(res.data.code != 1) return;
            this.listing.backendListDataParsingByProduct(res.data.info)
            this.$forceUpdate()
          }
        }
        obj[newVal]()
      }
    }
  },
  created(){
    let arr = [
      this.getProductList(),
      this.getStoreList()
    ]
    Promise.all(arr)
  }
}
</script>

<style lang="scss" scoped>
.new{
  width: 1400px;
  &-top{
    text-align: end;
    color: #fca605;
    font-size: 12;
    &__fun{
      text-decoration: underline;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &-progress{
    margin: 5px 0;
  }
  &-fun{
    display: flex;
    justify-content: end;
    &__btn{
      background: #00a0c7;
      color: white;
      padding: 5px 20px;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &-module{
    &__title{
      font-size: 18px;
      padding: 5px 0;
      font-weight: bold;
      color: black;
    }
    &__top{
      display: flex;
      border-bottom: 1px solid #00a0c7;
      &__name{
        padding: 5px 40px;
        background: #00a0c7;
        color: white;
        font-weight: bold;
      }
    }
    &-img{
      position: relative;
      margin-top: 10px;
      width: 170px;
      height: 170px;
      border: 1px solid #7f9db9;
      border-radius: 5px;
      &__add{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: inline-block;
        width: 76px;
        height: 76px;
        color: #ccc;
        position: relative;
        &::after, &::before{
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
        }
        &::before {
          width: 20px;
          border-top: 4px solid;
          margin: -2px 0 0 -10px;
        }
        &::after {
          height: 20px;
          border-left: 4px solid;
          margin: -10px 0 0 -2px;
        }
      }
      &__input{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 76px;
        height: 76px;
        opacity: 0;
        &:hover{
          cursor: pointer;
        }
      }
      &__image{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        height: 80%;
      }
      &__text{
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        width: 160px;
        text-align: center;
      }
      &__close{
        position: absolute;
        top: 0;
        left: 90%;
        width: 20px;
        height: 20px;
        transform: rotate(45deg);
        transition: color .25s;
        display: inline-block;
        color: #ccc;
        position: relative;
        &:hover{
          color: #7f9db9;
          cursor: pointer;
        }
        &::after, &::before{
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
        }
        &::before {
          width: 16px;
          border-top: 2px solid;
          margin: -1px 0 0 -8px;
        }
        &::after {
          height: 16px;
          border-left: 2px solid;
          margin: -8px 0 0 -1px;
        }
      }
    }
    &-item{
      display: flex;
      justify-content: center;
      margin: 10px;
    }
    &-list{
      position: relative;
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
      margin-right: 20px;
      ::v-deep{
        .el-input__inner{
          border-radius: 0;
          width: 220px;
        }
      }
      &--bottom{
        ::v-deep{
          .el-input__inner{
            border-radius: 0;
            width: 200px;
          }
          .el-input{
            width: 205px;
          }
        }
      }
      &__input{
        display: flex;
        justify-content: space-between;
        align-items: center;
        &-status{
          display: flex;
          padding: 5px 10px;
        }
        &-supplier{
          &__btn{
            padding: 5px 10px;
            font-size: 12px;
            color: #00a0c7;
            border-bottom: 1px solid #eeeeee;
            &:hover{
              cursor: pointer;
              opacity: .8;
            }
          }
          &__text{
            padding: 5px 10px;
            font-size: 12px;
            color: #00a0c7;
          }
        }
        &--size{
          ::v-deep{
            .el-input__inner{
              width: 70px;
              margin-right: 5px;
            }
          }
          & > :last-child{
            margin-right: -4px;
          }
        }
        &--remark{
          ::v-deep{
            .el-input__inner{
              width: 700px;
            }
          }
        }
        &--title{
          ::v-deep{
            .el-input__inner{
              width: 990px;
            }
          }
        }
        &--prompt{
          ::v-deep{
            .el-input__inner{
              border-color: red;
            }
          }
        }
      }
      &__name{
        width: 170px;
        text-align: end;
      }
      &__star{
        color: red;
      }
      &__tips{
        color: #00a0c7;
      }
      &__unit{
        margin-left: 5px;
        font-size: 12px;
      }
      &__function{
        position: absolute;
        right: -100px;
        display: flex;
        width: 100px;
        justify-content: left;
        &-input{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 0;
          cursor: pointer;
        }
      }
      &__btn{
        position: relative;
        font-size: 12px;
        text-align: center;
        width: 50px;
        line-height: 28px;
        height: 28px;
        border: 1px solid #c7c7c7;
        border-radius: 4px;
        margin-right: 2px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &-list1{
      margin-left: -10px;
    }
    &-bottom{
      display: flex;
      justify-content: end;
      &__btn{
        padding: 5px 20px;
        background: #00a0c7;
        color: white;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }
}
</style>
